var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"filterPane"}},[_c('div',{staticClass:"top-box"},[_vm._t("filter")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }